// SnackbarContext.js
import React, { createContext } from 'react';

export const SnackbarContext = createContext({
  showSnackbar: () => {},
});

export default SnackbarContext;